import { render, staticRenderFns } from "./ResetPasswordSendConfirmed.vue?vue&type=template&id=debc4318&scoped=true&"
import script from "./ResetPasswordSendConfirmed.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordSendConfirmed.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordSendConfirmed.vue?vue&type=style&index=0&id=debc4318&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debc4318",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
